import axios from '@/axios'
const accountinfo = {
  //获取账户资料基本信息
  async getIdentityInfo(params = '') {
    return await axios.post('/uc/user/userinfo/identityInfo', params, { des: '直客pc获取账户资料基本信息', sTime: new Date().getTime() })
  },
  //获取模拟客户基本资料 /uc/simulator/identityInfo
  async getSimulatorInfo(params = '') {
    return await axios.post('/uc/simulator/identityInfo', params, { des: '直客pc获取模拟客户基本资料', sTime: new Date().getTime() })
  },
  //发送验证码接口  /uc/sendcode
  async sendValidateCode(params) {
    return await axios.post('/uc/sendcode', params, { des: '直客pc发送验证码接口', sTime: new Date().getTime() })
  },
  //公共发送验证码接口
  async publicSendCode(params) {
    let url = params.url
    let data = params.data
    return await axios.post(url, data, { des: '直客pc公共发送验证码接口', sTime: new Date().getTime() })
  },
  //真实客户/模拟账户修改密码
  async resetPassword(params) {
    let url = params.url
    let data = params.data
    return await axios.post(url, data, { des: '直客pc真实客户/模拟账户修改密码 ', sTime: new Date().getTime() })
  },
  //申请代理
  async applyBeAgent(params) {
    return await axios.post('/uc/user/userinfo/applyBeAgent', params, { headers: { 'Content-Type': 'application/json' }, })
  },
  //银行卡列表
  async getBankList(params = '') {
    return await axios.post('/uc/user/bank/list', params, { des: '直客pc银行卡列表', sTime: new Date().getTime() })
  },
  //查看银行卡详情 /uc/user/bank/detail
  async getBankDetail(params) {
    return await axios.post('/uc/user/bank/detail', params, { des: '直客pc查看银行卡详情', sTime: new Date().getTime() })
  },
  //银行卡资料解除绑定   /uc/user/bank/removebind
  async removeCard(params) {
    return await axios.post('/uc/user/bank/removebind', params, { des: '直客pc银行卡资料解除绑定', sTime: new Date().getTime() })
  },
  //设置默认银行卡   /uc/user/bank/removebind
  async updateStatus(params) {
    return await axios.post('/uc/user/bank/updateStatus', params, { des: '直客pc设置默认银行卡', sTime: new Date().getTime() })
  },
  //提交身份证照片信息 /uc/user/userinfo/identityInfoSubmit
  async submitCardImg(params) {
    return await axios.post('/uc/user/userinfo/identityInfoSubmit', params, { des: '直客pc提交身份证照片信息 ', sTime: new Date().getTime() })
  },
  async uploadImg(params = '') {
    return await axios.post('/uc/user/userinfo/identityinfoimg', params, { des: '直客pc上传图片', sTime: new Date().getTime() })
  },
  //银行卡资料新增  /uc/user/bank/add
  async addBankCard(params) {
    if (params.id) {
      return await axios.post('/uc/user/bank/update', params, { des: '直客pc银行卡资料修改', sTime: new Date().getTime() })
    } else {
      return await axios.post('/uc/user/bank/add', params, { des: '直客pc银行卡资料新增', sTime: new Date().getTime() })
    }
  },
  //验证手机号是否重复   add by zy at 2022.4.28
  async repeatPhone(params) {
    return await axios.post('/uc/user/userinfo/isMobileExist', params, { des: '验证手机号是否重复', sTime: new Date().getTime() })
  },
  // 验证旧手机号
  async checkOldPhone(params) {
    return await axios.post('/uc/user/userinfo/checkOldPhone', params, { des: '验证旧手机', sTime: new Date().getTime() })
  },
  // 手机号绑定
  async mobileBind(params) {
    return await axios.post('/uc/user/userinfo/mobilebind', params, { des: '验证旧手机', sTime: new Date().getTime() })
  },
  // 根据卡号获取银行名称
  async getBankNameByNumber(params) {
    return await axios.get('/uc/bank/matchingBank', params, { des: '直客pc根据卡号获取银行名称', sTime: new Date().getTime() })
  },
  // 滑块  二要素 四要素 海外开关  1：二要素开关，2：四要素开户，3：海外开户开关 ，4:滑块开关
  async getBhswitch(params) {
    return await axios.get('/common/bhswitch', params, { des: '直客pc接口开关', sTime: new Date().getTime() })
  },
  async getip() {
    //return await axios.get('/ws/location/v1/ip', params, { baseUrl: '/ips' })
    return await axios.get('https://api.ipshudi.com/ipdata/?token=716c222fc13a282c92fdddf0540a1e9b',)
  },

  //获取国家地区
  async getCountry(params) {
    return await axios.post('/common/getCountry', params, { des: '直客pc获取国家地区', sTime: new Date().getTime() })
  },
  //同步验证手机号是否重复   add by zy at 2022.4.28
  repeatPhone2(params) {
    return axios.post('/uc/user/userinfo/isMobileExist', params, { async: false, des: '验证手机号是否重复', sTime: new Date().getTime() })
  },
  //验证邮件是否重复   add by zy at 2022.5.20
  async repeatEmail(params) {
    return await axios.post('/uc/user/userinfo/isEmailExist', params, { des: '验证邮件是否重复', sTime: new Date().getTime() })
  },
  // 同步发送邮件验证码
  publicSendCode2(params) {
    return axios.post('/uc/sendcode', params, { async: false, des: '发送邮件验证码', sTime: new Date().getTime() })
  },
  //邮件绑定   add by zy at 2022.5.20
  async emailbind(params) {
    return await axios.post('/uc/user/userinfo/emailbind', params, { des: '验证邮件是否重复', sTime: new Date().getTime() })
  },
  //查询用户是否填写问卷
  async getKYCRules(params) {
    return await axios.post('/uc/user/userinfo/getIsKYC', params, { des: '查询用户是否填写问卷', sTime: new Date().getTime() })
  },
  //获取KYC问卷列表
  async getIsKYCList(params) {
    return await axios.post('/uc/user/userinfo/getKYC', params, { des: '获取KYC问卷列表', sTime: new Date().getTime() })
  },
  //提交KYC问卷列表
  async postKYCList(params) {
    return await axios.post('/uc/user/userinfo/updateKYC', params, { des: '提交KYC问卷列表', sTime: new Date().getTime() })
  },
}

export default accountinfo



// WEBPACK FOOTER //
// ./src/api/accountinfo.js